module.exports = __webpack_public_path__ + "img/icon-tiyanke-logo.1d3af1a0.png";